export default __webpack_public_path__ + "f3aac72a8e63997d6bb888f816457e9b.png";